module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/features/accordian/accordian-style6/accordian-style6.component.scss
// module id = ./src/app/features/accordian/accordian-style6/accordian-style6.component.scss
// module chunks = main